import { render, staticRenderFns } from "./BottomComponent.vue?vue&type=template&id=c29a07e6&scoped=true"
import script from "./BottomComponent.vue?vue&type=script&lang=js"
export * from "./BottomComponent.vue?vue&type=script&lang=js"
import style0 from "./BottomComponent.vue?vue&type=style&index=0&id=c29a07e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29a07e6",
  null
  
)

export default component.exports